export default __webpack_public_path__ + "static/media/slots-full.4e6a7fe9.png";